export function normalizeRequestRecords(response) {
  if (!response) {
    return [];
  }
  if (Array.isArray(response)) {
    return response;
  }
  if (Array.isArray(response.records)) {
    return response.records;
  }
  return [];
}

export function buildCedexResultQuery(importId, sampleFilter, analyteFilter) {
  return {
    action: "query",
    cedex_import_id: importId,
    sample_like: sampleFilter || undefined,
    analyte_like: analyteFilter || undefined,
    order_by: "measured_at",
    order_desc: true,
    limit: 500,
  };
}
